import React from "react";
import { ToastContainer } from "react-toastify";

// A aparência vem das classes .Toastify__* definidas em globals.css, que já
// seguem os tokens de tema (claro/escuro) — por isso não passamos `theme`
// aqui: o tema do react-toastify perderia para aqueles !important.
const ThemedToastContainer = () => (
	<ToastContainer
		autoClose={3000}
		position="top-right"
		newestOnTop
		closeOnClick
		pauseOnHover
		draggable
		// Abaixo da barra de cima (`min-h-14`): no canto dela ficam o sino e a
		// busca, e o toast em cima tapava justamente o aviso que ele anuncia.
		style={{ top: "calc(3.5rem + env(safe-area-inset-top))" }}
	/>
);

export default ThemedToastContainer;
